declare const __brand: unique symbol;
type Brand<T, B> = T & { readonly [__brand]: B };

export type StationId = Brand<string, 'StationId'>;
export type TransactionId = Brand<number, 'TransactionId'>;
export type ConnectorId = Brand<number, 'ConnectorId'>;
export type EvseId = Brand<number, 'EvseId'>;
export type ChargingProfileId = Brand<number, 'ChargingProfileId'>;
export type VehicleProfileId = Brand<string, 'VehicleProfileId'>;

export const StationId = {
  of(raw: string): StationId {
    if (!UUID_V4_RE.test(raw)) {
      throw new RangeError(`StationId must be a UUID v4: got ${JSON.stringify(raw)}`);
    }
    return raw as StationId;
  },
};

export const TransactionId = {
  of(raw: number): TransactionId {
    if (!Number.isInteger(raw) || raw < 1 || raw > 2_147_483_647) {
      throw new RangeError(`TransactionId out of OCPP int32 range: ${raw}`);
    }
    return raw as TransactionId;
  },
};

export const ConnectorId = {
  of(raw: number): ConnectorId {
    if (!Number.isInteger(raw) || raw < 1) {
      throw new RangeError(`ConnectorId must be a positive integer: ${raw}`);
    }
    return raw as ConnectorId;
  },
};

export const EvseId = {
  of(raw: number): EvseId {
    if (!Number.isInteger(raw) || raw < 1) {
      throw new RangeError(`EvseId must be a positive integer: ${raw}`);
    }
    return raw as EvseId;
  },
};

export const ChargingProfileId = {
  of(raw: number): ChargingProfileId {
    if (!Number.isInteger(raw) || raw < 0) {
      throw new RangeError(`ChargingProfileId must be a non-negative integer: ${raw}`);
    }
    return raw as ChargingProfileId;
  },
};

export const VehicleProfileId = {
  of(raw: string): VehicleProfileId {
    if (!UUID_V4_RE.test(raw)) {
      throw new RangeError(`VehicleProfileId must be a UUID v4: got ${JSON.stringify(raw)}`);
    }
    return raw as VehicleProfileId;
  },
};

const UUID_V4_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
